"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastWrapper = exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const framer_motion_1 = require("framer-motion");
const _1 = require(".");
const utils_1 = require("../utils");
const styles_1 = require("../styles");
const getColorByType = (type) => {
    switch (type) {
        case 'info':
            return '#EFC881';
        case 'success':
            return '#5F895E';
        case 'warning':
            return '#A92329';
        case 'error':
            return '#A92329';
        default:
            return '#EFC881';
    }
};
exports.Toast = (0, react_1.memo)(({ message, type, icon, timeout = 5000, closeNeeded = false, onClose }) => {
    const [visible, setVisible] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        let timer;
        if (!closeNeeded) {
            timer = setTimeout(() => {
                setVisible(false);
            }, timeout);
        }
        return () => { clearTimeout(timer); };
    }, [timeout, closeNeeded]);
    const handleClose = (e) => {
        e.stopPropagation(); // Prevent the event from reaching the ToastContainer
        setVisible(false);
        if (onClose)
            onClose();
    };
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, Object.assign({ mode: 'wait' }, { children: visible &&
            (0, jsx_runtime_1.jsxs)(Div, Object.assign({ "$type": type, role: 'alert', "aria-relevant": 'additions', variants: variants, initial: 'initial', animate: 'animate', exit: 'exit' }, { children: [icon && (0, jsx_runtime_1.jsx)(_1.Figure, { media: (0, utils_1.iconByName)(icon) }), (0, jsx_runtime_1.jsx)("p", { children: message }), closeNeeded && (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleClose, name: 'Cerrar', "aria-label": 'Cerrar' }, { children: (0, jsx_runtime_1.jsx)(_1.Figure, { media: (0, utils_1.iconByName)('close') }) }))] })) })));
});
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  ${(0, styles_1.font12_15)(true, 400)}
  align-items: center;
  background-color: ${({ $type }) => getColorByType($type)};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  color: ${({ $type }) => ($type === 'warning' || $type === 'error' || $type === 'success') ? '#F3EFE6' : '#4E1114'};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  justify-content: space-between;
  margin: ${(0, styles_1.vw)(4, 'mobile')} 0;
  padding: ${(0, styles_1.vw)(4, 'mobile')} ${(0, styles_1.vw)(16, 'mobile')};
  pointer-events: auto;
  z-index: 999;
  width: 100vw;
  width: 100dvw;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin: ${(0, styles_1.vw)(4, 'tablet')} 0;
    padding: ${(0, styles_1.vw)(4, 'tablet')} ${(0, styles_1.vw)(16, 'tablet')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    ${(0, styles_1.font12_15)(false, 400)}
    margin: ${(0, styles_1.vw)(4, 'desktop')} 0;
    padding: ${(0, styles_1.vw)(4, 'desktop')} ${(0, styles_1.vw)(16, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin: 4px 0;
    padding: 4px 16px;
  }

  p {
    flex-grow: 2;
    flex-shrink: 0;
    text-align: center;
    width: 100%;
  }
`;
const variants = {
    initial: {
        opacity: 0,
        x: '100%',
        transition: { duration: .4 }
    },
    animate: {
        opacity: 1,
        x: '0%',
        transition: { duration: .4 }
    },
    exit: {
        opacity: 0,
        x: '100%',
        transition: { duration: .3 }
    }
};
exports.ToastWrapper = styled_components_1.default.aside `
  bottom: 0;
  left: 0;
  max-width: 100vw;
  pointer-events: none;
  position: fixed;
  right: 0;
  transition: 300ms all linear;
  user-select: none;
  width: 100%;
  z-index: 500;

  > div {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
